import React, {useState} from "react";
import {Button, Input, Modal, notification, Select,} from "antd";
import SharedService from "../../../services/shared/service";
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "oidc-react";
import {useJwt} from "react-jwt";

const {Option} = Select;
const {TextArea} = Input;
const DeleteInvoicePopup = ({isVisible, onClose, selectedItem}) => {
    const [statusOptions, setStatusOptions] = useState([]);
    const [selectedReason, setSelectedReason] = useState("");
    const [notes, setNotes] = useState("");
    const navigate = useNavigate();
    const {id} = useParams();
    const {userData, isLoading} = useAuth();
    const token = userData?.access_token;
    const {decodedToken, isExpired} = useJwt(token);


    const handlePopupCancel = () => {
        // Reset notes to initial value
        onClose();
    };
    const handleDeleteInvoice = () => {
        deleteInvoice(selectedItem.id)
        navigate("/invoice")
        onClose();


    }
    const deleteInvoice = (id) => {

        SharedService.delete({token, url: `document/${id}`})
            .then(() => {
                notification.success({
                    message: "Invoice Deleted Successfully",
                });
            })
            .catch(() => {
            });
    };


    return (
        <Modal
            open={isVisible}
            centered

            onCancel={handlePopupCancel}
            wrapClassName="reject-modal-wrapper"
            footer={[
                <Button key="cancel" id="close-btn" onClick={handlePopupCancel}>Cancel</Button>,
                <Button key="submit" id="submit-btn" type="primary" danger onClick={handleDeleteInvoice}>Delete</Button>,
            ]}
            closable={true}
        >
            <div className="font-bold mb-6 text-[17px]">Are you sure you want to delete the Invoice?</div>

            <style>
                {`
        .reject-modal-wrapper #submit-btn:hover {
            background-color: #020A08 !important;
        }
        .reject-modal-wrapper #close-btn{
            border: 1px solid #020A08 !important;
            color: #020A08 !important;
        }
        .reject-modal-wrapper .ant-select-dropdown{
           width:300px !important;
          }
          .reject-modal-wrapper .ant-select:not(.ant-select-customize-input) .ant-select-selector {
           
            border-radius: 32px;
          
        }
        .reject-modal-wrapper textarea.ant-input {
            border-radius: 10px;
        }
        .reject-modal-wrapper #close-btn:hover{
            background: #020A08 !important;
            color: white !important;
        }`}
            </style>
        </Modal>
    );
};
export default DeleteInvoicePopup;
